//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderStatusLangs', {
//        templateUrl: 'views/components/views/orderStatusLangs/orderStatusLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'orderStatusLangsService', function ($stateParams, stateService, orderStatusLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderStatusId = $stateParams.orderstatus_id;

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await orderStatusLangsService.listOrderStatusLanguages({ orderstatus_id: orderStatusId });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                orderStatusLangsService.saveObj({ records: vm.model.inputListLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
